import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { company, heroImg } from "../../mock";

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative min-h-[90vh] flex items-center overflow-hidden">
    <img src={heroImg} alt="Abstract network" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#05071F] via-[#05071F]/85 to-[#05071F]/40" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-16 w-full">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-6">{company.overline}</p>
      <h1 data-testid="hero-headline" className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-medium text-white max-w-3xl leading-[1.05]">
        <span className="block">Guarding Systems.</span>
        <span className="block">Empowering Growth.</span>
        <span className="block text-cyan-400">Architecting the Future.</span>
      </h1>
      <p className="mt-8 text-base sm:text-lg text-slate-300 max-w-xl leading-relaxed">{company.subtext}</p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link to="/intake" data-testid="hero-cta-primary"
          className="inline-flex items-center gap-2 bg-cyan-400 text-[#05071F] font-semibold px-7 py-3.5 rounded-full hover:bg-cyan-300 transition-colors">
          Talk to an Advisor <ArrowRight className="w-4 h-4" />
        </Link>
        <a href="#solutions" data-testid="hero-cta-secondary"
          className="inline-flex items-center gap-2 border border-white/20 text-white px-7 py-3.5 rounded-full hover:border-white/50 transition-colors">
          Explore Solutions
        </a>
      </div>
      <p className="mt-12 text-sm text-slate-500 uppercase tracking-widest">{company.location} · {company.serving}</p>
    </div>
  </section>
);
